import { ContratarRecargaCertaService } from './../../services/contratar-recarga-certa.service';
import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { HttpClient } from '@angular/common/http';


import { UntypedFormBuilder, UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { take } from 'rxjs/operators';
import { TermoService, TermoAdesaoTeplateDTO } from '@services/termo.service';
import { LoadingGenericoComponent } from '../../components/loading-generico/loading-generico.component';
import { AlertErroComponent } from '../../components/alert-erro/alert-erro.component';
import { HeaderComponent } from '../../components/header/header.component';
import { BotaoChatComponent } from '../../components/botao-chat/botao-chat.component';
import { BreadcrumbComponent } from '../../components/breadcrumb/breadcrumb.component';
import { SelectComponent } from '../../components/select/select.component';
import { NgClass } from '@angular/common';
import { FooterComponent } from '../../components/footer/footer.component';

@Component({
    selector: 'app-contratar-recarga-certa',
    templateUrl: './contratar-recarga-certa.component.html',
    styleUrls: ['./contratar-recarga-certa.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [LoadingGenericoComponent, AlertErroComponent, HeaderComponent, BotaoChatComponent, FormsModule, ReactiveFormsModule, BreadcrumbComponent, SelectComponent, NgClass, FooterComponent]
})
export class ContratarRecargaCertaComponent implements OnInit {
  termo: TermoAdesaoTeplateDTO;
  termoTexto: string = '';
  formulario: UntypedFormGroup
  showAlertConfirmacao: boolean = false;
  showAlertSucesso: boolean = false;

  public loadingGenerico: boolean = false;
  public empresa: any = localStorage.idEmpresaLogada;
  public resources: any;
  public aprovadores: any = [];
  public idContato : any;
  public ip : any;

  public alertErro: boolean = false;
  public mensagemErro: any;
  public taxa:any = 'ERRO';
  public botao2 : any = true;
  public tituloMensagemErro : any = "Ocorreu um erro ao contratar recarga certa!";

  constructor(
    private readonly formularioBuilder: UntypedFormBuilder,
    private readonly Toastr: ToastrService,
    private readonly contratarRecargaCertaService : ContratarRecargaCertaService,
    private readonly termoService: TermoService,
    private readonly http : HttpClient
    ) { }

  ngOnInit(): void {
    this.constroiFormulario();
    this.getContrato();
    this.getIpUsuario();
    this.obterTermoTemplate();
  }

obterTermoTemplate(): void {
  this.termoService.getTermoTemplate()
  .pipe(take(1))
  .subscribe({
    next: (data: TermoAdesaoTeplateDTO) => {
      this.termo = data;
      this.termoTexto = this.converterTermoParaTexto(data);
    },
    error: (error) => {
      console.error('Erro ao obter o termo', error);
      this.alertErro = true;
      this.mensagemErro = 'Erro ao obter termo de adesão.';
    }
  });
}

converterTermoParaTexto(termo: TermoAdesaoTeplateDTO): string {
  if (!termo) { return ''; }
  let texto = '';
  if (termo.sections && termo.sections.length > 0) {
    termo.sections.forEach(section => {
      texto += section.sectionTitle + '\n\n';
      if (section.paragraphs && section.paragraphs.length > 0) {
        section.paragraphs.forEach((paragrafo: string) => {
          texto += paragrafo + '\n\n';
        });
      }
    });
  }
  return texto;
}

  public getContrato() {
    this.loadingGenerico = true;
    this.contratarRecargaCertaService.getContrato(this.empresa)
      .pipe(take(1))
      .subscribe({
        next: (success: any) => {
          this.loadingGenerico = false;
          this.resources = success;
          this.taxa=success.taxa;
          this.aprovadores = success.Aprovadores;
        },
        error: (error) => {
          this.loadingGenerico = false;
          this.alertErro = true;
          this.mensagemErro = 'Erro ao carregar dados do contrato! ';
        }
      });
  }

  getIpUsuario(){
    fetch('https://ipv4.jsonip.com', { mode: 'cors' })
    .then((resp) => resp.json())
    .then((ip) => {
      this.ip = ip.ip;
    });
  }

  public getContratar() {

    this.idContato = this.formulario.value.idAprovador;

    this.loadingGenerico = true;
    this.contratarRecargaCertaService.getContratar(this.empresa , this.idContato , this.ip )
      .pipe(take(1))
      .subscribe({
        next: (success: any) => {
          this.loadingGenerico = false;
          this.fecharAlertConfirmacao('contratar');
          this.formulario.reset();
        },
        error: (error) => {
          this.loadingGenerico = false;
          this.alertErro = true;
          this.showAlertConfirmacao = false;
          this.mensagemErro = error.error.mensagem;
          this.formulario.reset();
        }
      });
  }

  constroiFormulario() {
    this.formulario = this.formularioBuilder.group({
      'idAprovador': ['', Validators.compose([ Validators.required ])],
      'aceitarTermo': ['', Validators.compose([ Validators.required ])],
    });
  }

  onSubmit(){
    this.showAlertConfirmacao = true;
  }

  fecharAlertConfirmacao(acao: string) {
    if(acao === 'contratar') {
      this.showAlertConfirmacao = false;
      this.showAlertSucesso = true;
    } else {
      this.showAlertConfirmacao = false;
    }
  }

  fecharAlertSucesso() { this.showAlertSucesso = false; }
  
  public fecharAlertErro(event: any) {
    this.alertErro = event;
  }
}
